import * as homepage from './A11y_homePage.js';
import * as header from './A11y_header.js';
import * as allProducts from './A11y_allProductsPage.js';
import * as pdp from './A11y_ProductDetailedPage.js';
import * as cartModal from './A11y_cartModal.js';
import * as cartSummary from './A11y_cartDetailedPage.js';
import * as aboutUs from './A11y_aboutUsPage.js';
import * as allFields from './A11y_allFieldNotesPage.js';
import * as footer from './A11y_footer.js';
import * as orders from './A11y_orderPage.js';
import * as addresses from './A11y_addressPage.js';
import * as orderDetails from './A11y_orderDetailsPage.js';
import * as login from './A11y_loginPage.js';
import * as fpHeader from './A11y_forgetPasswordPage.js';
import * as termsOfUse from './A11y_TermsOfUsePage.js';
import * as cart from './A11y_CartPage.js';
import * as ordersPage from './A11y_OrdersPage.js';
import * as checkout from './A11y_CheckoutPage.js';
import * as orderAT from './A11y_OrderArrivalTimes.js'
import * as faq from './A11y_FrequentlyAskedQuestions.js';
import * as warranty from './A11y_Warranty.js';
import * as reviews from './A11y_Reviews.js';
import * as rae from './A11y_ReturnAndExchanges.js';
import * as compare from './A11y_Compare.js';
import * as critical from './A11y_criticalFixes.js';
document.addEventListener("readystatechange", (event) => {
    if(event.target.readyState === "interactive") {

    }
    if(event.target.readyState === "complete") {
        console.log("Document is complete. Files Loaded.");
        critical.applyCriticalFixes();
        login.applyLoginPageFixes();
        header.applyHeaderFixes();
        homepage.applyHomePageFixes();
        footer.applyFooterFixes();
        cart.applyCartFixes();
        allProducts.applyProductListFixes();
        pdp.applyPDPFixes();
        cartModal.applyCartModalFixes();
        cartSummary.shoppingCartFixes();
        aboutUs.applyAboutUsFixes();
        allFields.applyAllFieldFixes();
        orders.applyFixesForOrderPage();
        addresses.applyFixesOnAddressPage();
        orderDetails.applyOrderDetailFixes();
        termsOfUse.applyTermsOfUseFixes();
        fpHeader.applyForgetPaswordPageFixes();
        checkout.applyCheckoutFixes();
        ordersPage.applyOrderFixes();
        orderAT.applyOrderArrivalTimesFixes();
        faq.applyFAQFixes();
        warranty.applyWarrantyFixes();
        reviews.applyReviewsFixes();
        rae.applyReturnAndExchangesFixes();
        compare.applyComparePageFixes();
    }
});